export const hierarchyMessages = {
	TOASTS: {
		REALLOCATE_SUCCESS:
			'Registros realocados com sucesso para "Não Informado".',
		DELETE_SUCCESS: 'Hierarquia excluída com sucesso!',
		DELETE_STARTED:
			'Exclusão iniciada com sucesso! Estamos processando os registros selecionados. Isso pode levar alguns minutos.',
		RECORDS_DELETED_SUCCESS: 'Registros excluídos com sucesso.',
		INTERNAL_ERROR:
			'Erro interno ao processar a operação. Caso persista, entre em contato com o suporte.',
		REQUIRED_OPTION_TITLE: 'É obrigatório escolher uma opção.',
		REQUIRED_OPTION_DESCRIPTION:
			'Selecione realocar ou excluir registros para continuar.',
		REQUIRED_TYPE_DESCRIPTION:
			'Selecione pelo menos um tipo de registro para excluir.',
		OPERATION_CANCELLED: 'Operação cancelada pelo usuário.',
	},

	DELETE: {
		SUCCESS_TITLE: 'Excluido com sucesso!',
		SUCCESS_DESCRIPTION: 'A hierarquia foi excluida com sucesso.',
		ERROR_TITLE: 'Erro ao excluir hierarquia!',
		CONFIRM_TITLE: 'Deseja realmente excluir esta hierarquia?',
		CONFIRM_TEXT: [
			'Você está prestes a excluir esta hierarquia da sua base de cadastros.',
			'',
			'Você tem certeza que deseja excluir?',
		],
		BULK_MESSAGE: [
			'Você está prestes a excluir estas hierarquias da sua base de cadastros.',
			'',
		],
		BULK_SUCCESS_TITLE: 'Registros excluídos com sucesso!',
		BULK_SUCCESS_DESCRIPTION: 'As hierarquias foram excluídas com sucesso',
		BULK_ERROR_TITLE: 'Erro ao excluir hierarquias!',
	},

	HELP: {
		TITLE: 'Hierarquia',
		FIRST_PARAGRAPH:
			'Nesta tela é possível visualizar a Hierarquia Comercial, refletindo a organização comercial do seu negócio, contendo todos os níveis de iteração. A hierarquia, do nível macro ao micro, é composta por Mercado > Canal de Venda > Força de Venda > Zona de Venda > Membro.',
		SECOND_PARAGRAPH:
			'O membro se refere ao responsável pela venda, garantindo a alocação correta da receita. Acesse o botão Cadastrar Hierarquia para adicionar novas hierarquias comerciais.',
	},

	MENU: {
		VIEW_MARKETS: 'Ver mercados',
		VIEW_SALES_CHANNELS: 'Ver canais de venda',
		VIEW_SALES_FORCES: 'Ver forças de venda',
		VIEW_SALES_ZONES: 'Ver zonas de venda',
	},

	BUTTONS: {
		IMPORT_HIERARCHIES: 'Importar Hierarquias',
		IMPORT_DATA_TITLE: 'Importar Dados de Hierarquias',
		CREATE_HIERARCHIES: 'Cadastrar Hierarquias',
		EXPORT_TOOLTIP: 'Exportar Hierarquias para CSV',
		CONFIRM_DELETE_REALLOCATE: 'Confirmar exclusão / realocação',
		CONFIRM_DELETE: 'Confirmar exclusão',
		CANCEL: 'Cancelar',
		CREATE: 'Criar',
	},

	MODAL_DELETE: {
		TITLE: 'Tem certeza que deseja excluir esta Hierarquia Comercial?',
		LOADING: 'Carregando informações...',
		NO_RECORDS:
			'Nenhum registro relacionado encontrado. A hierarquia será excluída diretamente.',
		HAS_RECORDS:
			'Esta hierarquia possui registros relacionados. Escolha o que deseja fazer com esses dados antes de concluir a exclusão.',
		OPTION_REALLOCATE:
			'Realocar todos os registros atrelados a esta hierarquia para "Não Informado"',
		OPTION_DELETE:
			'Excluir definitivamente os registros relacionados à hierarquia selecionada.',
		SELECT_TYPES_TITLE: 'Selecione os tipos de registros para excluir:',
		SELECT_ALL: 'Selecionar todas as opções abaixo',
		RECORD_COUNT: 'registros',
		VOLUME_WARNING:
			'Esta ação pode levar alguns minutos devido ao volume de dados.',
	},

	MODAL_CREATE: {
		TITLE: 'Deseja criar uma nova hierarquia comercial?',
		DESCRIPTION:
			'Hierarquia comercial informada será criada, pois ainda não existe.',
	},
} as const;

export type HierarchyMessageType =
	(typeof hierarchyMessages)[keyof typeof hierarchyMessages];
